






import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {Chart} from 'highcharts-vue';
import More from 'highcharts/highcharts-more';
import Highcharts from 'highcharts';
import {colors} from '@/config';
import KeyValue from '@/utils/KeyValue';

More(Highcharts);

@Component({components: {Chart}})
export default class CompassIndustryNew extends Vue {
  @Prop() readonly rankings!: any;

  component: any = undefined;
  hovered: number | null = null;

  chartOptions: any = {
    chart: {
      polar: true,
      type: 'area',
      height: '69%',
      backgroundColor: 'transparent',
      events: {
        click: this.onClick,
      },
    },

    credits: {
      enabled: false,
    },

    title: {
      text: '',
    },

    pane: {
      // size: '100%',
    },

    xAxis: {
      // tslint:disable-next-line:max-line-length
      categories: ['<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Avkastning') + '</span>', Vue.prototype.$t('Rörelsemarginal'), Vue.prototype.$t('Tillväxt'), '<span  style="font-weight: 600; color: black;">' + Vue.prototype.$t('Framtidsutsikter') + '</span>', Vue.prototype.$t('Soliditet'), Vue.prototype.$t('Rörelsekapital i % av omsättning'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Finansiell styrka') + '</span>', Vue.prototype.$t('Kassalikviditet'), Vue.prototype.$t('Räntetäckningsgrad'), '<span style="font-weight: 600; color: black;">' + Vue.prototype.$t('Kortsiktig beredskap') + '</span>', Vue.prototype.$t('Riskbuffert'), Vue.prototype.$t('Räntabilitet på eget kapital')],
      tickmarkPlacement: 'on',
      lineWidth: 0,
      labels: {
        enabled: true,
        style: {
          fontSize: '1rem',
        },
        distance: 25,
      },
      plotLines: [{
        color: colors.Black,
        width: 2,
        value: 3,
        zIndex: 2,
      },
        {
          color: colors.Black,
          width: 2,
          value: 6,
          zIndex: 2,
        },
        {
          color: colors.Black,
          width: 2,
          value: 9,
          zIndex: 2,
        },
        {
          color: colors.Black,
          width: 2,
          value: 12,
          zIndex: 2,
        },
      ],
      gridLineColor: colors.LightGrey,
    },

    yAxis: {
      gridLineInterpolation: 'polygon',
      lineWidth: 0,
      min: 0,
      max: 100,
      tickInterval: 10,
      gridLineColor: colors.LightGrey,
      gridLineDashStyle: 'longdash',
      labels: {
        enabled: false,
      },
    },

    tooltip: {
      shared: true,
      useHTML: true,
      positioner: () => {
        return {
          x: -100000,
          y: -100000,
        };
      },
    },

    legend: {
      reversed: false,
      enabled: true,
      floating: true,
      borderWidth: 1,
      padding: 16,
      backgroundColor: colors.Light,
      align: 'left',
      verticalAlign: 'top',
      borderColor: colors.LightGrey,
      borderRadius: '0.2rem',
      x: '-0.5rem',
      y: '-0.5rem',
      layout: 'vertical',
      itemStyle: {
        font: '1rem Assistant, Verdana, sans-serif',
      },
    },

    plotOptions: {
      series: {
        animation: true,
        fillOpacity: 0.5,
        marker: {
          radius: 0,
          states: {
            hover: {
              radius: 5,
            },
          },
          symbol: 'circle',
        },
        lineWidth: 1,
        pointPlacement: 'on',
        point: {
          events: {
            mouseOver: this.onMouseOver,
            click: this.onClick,
          },
        },
        events: {
          mouseOut: this.onMouseOut,
        },
      },
    },

    series: [],
  };

  onMouseOver(e: any) {
    this.hovered = e.target.index;
    this.component.$emit('hover', KeyValue.ByIndex(this.hovered as number));
  }

  onMouseOut() {
    this.hovered = null;
    this.component.$emit('hover', null);
  }

  onClick(e: any) {
    if (!this.hovered || this.hovered % 3 === 0) {
      return;
    }
    this.component.$emit('clicked');
  }

  @Watch('rankings', { immediate: true, deep: true })
  onRankingsChanged() {
    if (this.rankings === undefined) {
      return;
    }
    if (this.rankings.sheets === undefined) {
      return;
    }

    const sheet = this.rankings.sheets[0];

    const s1 = this.addData({
      name: `${sheet.DATE_TO.substring(0, 7)} (${sheet.MONTHS} ${Vue.prototype.$t('mån')})`,
      pointPlacement: 'on',
      fillOpacity: 0.5,
      color: colors.Primary,
      zIndex: 6,
      // marker: {
      //   enabled: false,
      //   symbol: 'circle',
      //   fillColor: colors.Primary,
      //   lineWidth: 2,
      //   lineColor: null, // inherit from series
      // },
    }, sheet.ranks, sheet.keyValues);

    const industry = this.addData({
      name: Vue.prototype.$t('Branschmedian'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.DarkGrey,
      dashStyle: 'longdash',
      zIndex: 5,
    }, sheet.industryRanks, sheet.industryKeyValues);

    const industry25 = this.addData({
      name: Vue.prototype.$t('Undre kvartil'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.Negative,
      lineColor: colors.Negative,
      zIndex: 5,
    }, sheet.industryRanks25, sheet.industryKeyValues25);

    const industry75 = this.addData({
      name: Vue.prototype.$t('Övre kvartil'),
      pointPlacement: 'on',
      fillOpacity: 0,
      color: colors.Positive,
      lineColor: colors.Positive,
      zIndex: 5,
    }, sheet.industryRanks75, sheet.industryKeyValues75);

    const industryArea = {
      name: 'Area',
      showInLegend: false,
      fillOpacity: 0.5,
      color: colors.LightGrey,
      zIndex: 1,
      data: [
        [1, sheet.industryRanks25.operatingMargin],
        [2, sheet.industryRanks25.growth],
        [3, sheet.industryRanks25.longTerm],
        [4, sheet.industryRanks25.solidity],
        [5, sheet.industryRanks25.workingCapitalPct],
        [6, sheet.industryRanks25.financialStrength],
        [7, sheet.industryRanks25.quickRatio],
        [8, sheet.industryRanks25.interestCoverage],
        [9, sheet.industryRanks25.shortTerm],
        [10, sheet.industryRanks25.riskBuffer],
        [11, sheet.industryRanks25.returnOnCapital],
        [0, sheet.industryRanks25.yield],
        [1, sheet.industryRanks25.operatingMargin],
        [1, sheet.industryRanks75.operatingMargin],
        [0, sheet.industryRanks75.yield],
        [11, sheet.industryRanks75.returnOnCapital],
        [10, sheet.industryRanks75.riskBuffer],
        [9, sheet.industryRanks75.shortTerm],
        [8, sheet.industryRanks75.interestCoverage],
        [7, sheet.industryRanks75.quickRatio],
        [6, sheet.industryRanks75.financialStrength],
        [5, sheet.industryRanks75.workingCapitalPct],
        [4, sheet.industryRanks75.solidity],
        [3, sheet.industryRanks75.longTerm],
        [2, sheet.industryRanks75.growth],
        [1, sheet.industryRanks75.operatingMargin],
      ],
    };

    this.chartOptions.series = [s1, industry25, industry, industry75, industryArea];
  }

  addData(series: any, ranks: any, kv: any) {
    series.data = KeyValue.Items.map((item) => ({
      name: item.Name(),
      y: item.Value(ranks),
      keyfigure: item.KeyFigure(kv),
    }));
    return series;
  }

  created() {
    this.component = this;
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
  }

  destroyed() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize() {
    // this.chartOptions.chart.spacingLeft = this.vw(20);
  }

  vw(vw: number): number {
    return window.innerWidth * vw / 100.0;
  }

  get filters(): any {
    return (Vue as any).options.filters;
  }

  get cursor() {
    if (!this.hovered || this.hovered % 3 === 0) {
      return 'default';
    } else {
      return 'pointer';
    }
  }
}


